import React from 'react';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import {
  Button,
  Divider,
  FormControlLabel,
  FormLabel,
  Paper,
  Radio,
  RadioGroup,
  Typography,
} from '@material-ui/core';
import { useStyles } from './DocListModal.styles';

const DeliveryDocListModal = ({ open, onSelect, onClose, docTypeList }) => {
  const classes = useStyles();
  const [value, setValue] = React.useState();

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={open}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}>
      <Fade in={open}>
        <Paper className={classes.paper}>
          <div className="ml-3 pt-5 pb-5">
            <Typography variant="h5" className="mb-3" style={{ fontFamily: 'font-semibold' }}>
              Tag Image to Document
            </Typography>
            <RadioGroup
              aria-label="gender"
              name="customized-radios"
              value={value}
              onChange={handleChange}>
              {docTypeList?.map((e) => {
                return <FormControlLabel value={e._id} control={<StyledRadio />} label={e.name} />;
              })}
            </RadioGroup>{' '}
          </div>
          <div className={classes.buttonGroup}>
            <Button className={`${classes.goHomeButton} `} onClick={onClose}>
              Close
            </Button>
            <Divider orientation="vertical" flexItem className={classes.verticalDivider} />
            <Button className={`${classes.continueButton}`} onClick={() => onSelect(value)}>
              Select
            </Button>
          </div>
        </Paper>
      </Fade>
    </Modal>
  );
};

function StyledRadio(props) {
  const classes = useStyles();

  return (
    <Radio
      className={classes.root}
      disableRipple
      color="default"
      checkedIcon={<span className={classes.checkedIcon} />}
      icon={<span className={classes.icon} />}
      {...props}
    />
  );
}

export default DeliveryDocListModal;
